export default "__VITE_ASSET__B4HYH3VU__"